import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

const GROUPS = [
  { key: "nowReading" as const, label: "Now reading", icon: "menu_book" },
  { key: "influences" as const, label: "Influences", icon: "auto_stories" },
  { key: "listening" as const, label: "Listening", icon: "podcasts" },
];

const BG_PALETTE = [
  "var(--md-sys-color-primary-container)",
  "var(--md-sys-color-secondary-container)",
  "var(--md-sys-color-tertiary-container)",
];
const FG_PALETTE = [
  "var(--md-sys-color-on-primary-container)",
  "var(--md-sys-color-on-secondary-container)",
  "var(--md-sys-color-on-tertiary-container)",
];

export function Reading() {
  const R = portfolio.reading;

  return (
    <section id="reading" className="md-section">
      <div className="md-container">
        <SectionHead num="10" eyebrow="Reading list / Influences" title="What's actually shaping the work." />

        <div className="m3-reading__cols">
          {GROUPS.map((g, gi) => {
            const items = R[g.key];
            const isShelf = typeof items[0] === "object";
            return (
              <div
                key={g.key}
                className={"md-card md-card--" + (gi === 0 ? "filled" : "outlined") + " md-card__pad m3-reading__col"}
              >
                <div className="m3-reading__head">
                  <span className="material-symbols-rounded icon-20">{g.icon}</span>
                  <span className="md-title-m">{g.label}</span>
                </div>
                {isShelf ? (
                  <ul className="md-list" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    {(items as { title: string; author: string; note?: string }[]).map((it, i) => (
                      <li
                        key={i}
                        style={{ display: "grid", gridTemplateColumns: "32px 1fr", gap: 12, alignItems: "start" }}
                      >
                        <span
                          style={{
                            width: 32,
                            height: 40,
                            borderRadius: 4,
                            background: BG_PALETTE[i % 3],
                            color: FG_PALETTE[i % 3],
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontFamily: "var(--md-sys-typescale-brand)",
                            fontSize: 13,
                            fontWeight: 500,
                          }}
                        >
                          {(it.author || it.title)[0]}
                        </span>
                        <div>
                          <div className="md-title-s">{it.title}</div>
                          {it.author && <div className="md-body-s dim">{it.author}</div>}
                          {it.note && (
                            <div className="md-body-s" style={{ marginTop: 4 }}>
                              {it.note}
                            </div>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="md-chip-group">
                    {(items as string[]).map((s, i) => (
                      <span key={i} className="md-chip md-chip--assist">
                        {s}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
